import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import { getOptionsForFeature, OwsOptionsFeatureType, } from 'owa-outlook-service-options';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { getIsDarkTheme } from 'owa-fabric-theme';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
export function getReadStaticActions() {
    var actions = [
        { key: 'Reply', hideInGroup: true, hideInSxS: false },
        { key: 'ReplyAll', hideInGroup: false, hideInSxS: false },
        { key: 'Forward', hideInGroup: false, hideInSxS: false },
        { key: '-', hideInGroup: false, hideInSxS: false },
        { key: 'Delete', hideInGroup: false, hideInSxS: true },
        { key: '-', hideInGroup: false, hideInSxS: false },
        { key: 'MarkReadUnread', hideInGroup: false, hideInSxS: true },
        { key: 'FlagUnflag', hideInGroup: true, hideInSxS: true },
        { key: '-', hideInGroup: false, hideInSxS: false },
    ];
    if (!getUserConfiguration().SessionSettings.IsShadowMailbox) {
        actions.push({ key: 'MarkJunkNotJunk', hideInGroup: true, hideInSxS: true }, { key: 'MarkAsPhishing', hideInGroup: true, hideInSxS: true }, { key: 'Block', hideInGroup: true, hideInSxS: true }, { key: '-', hideInGroup: false, hideInSxS: false });
    }
    actions.push({ key: 'CreateRule', hideInGroup: true, hideInSxS: true }, { key: 'Print', hideInGroup: false, hideInSxS: false });
    if (isMailFeatureEnabled('gsx-translator-translateMessage')) {
        actions.push({ key: 'Translate', hideInGroup: true, hideInSxS: true });
    }
    if (getIsDarkTheme()) {
        actions.push({ key: 'ToggleDarkMode', hideInGroup: false, hideInSxS: false });
    }
    if (isMailFeatureEnabled('rp-immersiveReader')) {
        actions.push({ key: 'ShowInImmersiveReader', hideInGroup: false, hideInSxS: true });
    }
    if (isControlFeatureEnabled('doc-consumerUrl')) {
        actions.push({ key: 'ViewMessageSource', hideInGroup: true, hideInSxS: true });
    }
    if (isMailFeatureEnabled('rp-popouts')) {
        actions.push({ key: 'Popout', hideInGroup: false, hideInSxS: true });
    }
    if (isMailFeatureEnabled('rp-like') && !isConsumer()) {
        actions.push({ key: 'LikeUnlike', hideInGroup: false, hideInSxS: true });
    }
    return actions;
}
export function getComposeStaticActions() {
    var actions = [
        { key: 'AddAttachment', hideInGroup: false },
        { key: 'AddInlineImage', hideInGroup: false },
        { key: 'AddEmoji', hideInGroup: false },
        { key: 'ToggleRibbon', hideInGroup: false },
        { key: 'SaveDraft', hideInGroup: false },
        { key: 'InsertSignature', hideInGroup: false },
        { key: 'ShowFrom', hideInGroup: false },
        { key: 'SetImportance', hideInGroup: false },
    ];
    if (isMailFeatureEnabled('cmp-encryption') &&
        (!isConsumer() || getUserConfiguration().SessionSettings.IsPremiumConsumerMailbox)) {
        actions.push({ key: 'ProtectMessage', hideInGroup: false });
    }
    actions.push({ key: 'SwitchBodyType', hideInGroup: false });
    if (isMailFeatureEnabled('cmp-accChecker')) {
        actions.push({ key: 'AccChecker', hideInGroup: false });
    }
    return actions;
}
export function shouldAddActionToEnd(action) {
    // Reply, ReplyAll, and Forward are the first 3 actions in the set of static actions in the reading pane.
    // While all other actions should render from right to left based on their order in the settings,
    // the desire is for these three to render left to right, so they should be inserted at the end of the collection.
    return action == 'Reply' || action == 'ReplyAll' || action == 'Forward';
}
export function shouldActionBeOnSurface(actionKey) {
    var surfaceActionsOptions = getOptionsForFeature(OwsOptionsFeatureType.SurfaceActions);
    return surfaceActionsOptions.readSurfaceActions.indexOf(actionKey) !== -1;
}
//# sourceMappingURL=getStaticActions.js.map